define('config',[], function () {
	"use strict";

	return {
		adwords:
		{
			tracking: "/adwords/tracking/"
		},
		admin:
		{
			home: "/admin/",
			authentication:
			{
				login: "/api/authentication/login",
				logout: "/api/authentication/logout"
			},
			blog:
			{
				getPosts: "/api/blog/getposts",
				editPostPage: "/admin/blog/edit",
				post: "/api/blog/post",
				deletePost: "/api/blog/deletePost",
				picture: "/api/blog/picture"
			}
		}
	};
});
